<head>
  <!-- Required meta tags -->
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

  <!-- Bootstrap CSS -->
  <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
    integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
</head>


<div class="container-fluid">
  <div class="row">
    <h5 class="border-bottom">Associations</h5>
    <nav class="navbar navbar-light bg-light justify-content-between">
      <a class="navbar-brand"></a>
      <div class="input-group search-style">
       <input class="form-control mr-sm-1" type="search" [(ngModel)]="searchTerm" placeholder="Search">
        <div class="input-group-append">
          <button class="btn removefocus" type="button" (click)="search()" *ngIf="!isSearching">  
                      <i class="fa fa-search"></i>
          </button>
          <button class="btn removefocus" type="button" (click)="clearSearch()" *ngIf="isSearching">
          <i class="fa fa-times"></i>
                </button>

        </div>
     
      </div>
   
    </nav>

    <section class="table-container " [ngClass]="{ 'table-container-collapsed':!dynamicTabService.isCollapsed}"
      tabindex="0">
      <div>
        <table mat-table [dataSource]="dataSource" matSort class="table table-bordered">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef >
              <button class="btn btn-link" (click)="sortData('name')" matTooltip="Sort by Name">
                Name
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !== 'name'"
                  [class.fa-sort-asc]="sortingColumn === 'name' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn === 'name' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">
              <a (click)="sendIdtochild(association)">
                {{ association.name }}
              </a>
            </td>
          </ng-container>
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('code')" matTooltip="Sort by Code">
                Code
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='code'"
                  [class.fa-sort-asc]="sortingColumn ==='code' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='code' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.code }}</td>
          </ng-container>
          <ng-container matColumnDef="address1">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('address1')" matTooltip="Sort by Address1">
                Address1
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='address1'"
                  [class.fa-sort-asc]="sortingColumn ==='address1' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='address1' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.address1 }}</td>
          </ng-container>
          <ng-container matColumnDef="address2">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('address2')" matTooltip="Sort by Address2">
                Address2
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='address2'"
                  [class.fa-sort-asc]="sortingColumn ==='address2' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='address2' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.address2 }}</td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('city')" matTooltip="Sort by City">
                City
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='city'"
                  [class.fa-sort-asc]="sortingColumn ==='city' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='city' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.city }}</td>
          </ng-container>
          <ng-container matColumnDef="stateId">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('stateId')" matTooltip="Sort by State">
                State
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='stateId'"
                  [class.fa-sort-asc]="sortingColumn ==='stateId' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='stateId' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.stateId }}</td>
          </ng-container>
          <ng-container matColumnDef="postalCode">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('postalCode')" matTooltip="Sort by Postal Code">
                Postal Code
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='postalCode'"
                  [class.fa-sort-asc]="sortingColumn ==='postalCode' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='postalCode' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.postalCode }}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('email')" matTooltip="Sort by Email">
                Email
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='email'"
                  [class.fa-sort-asc]="sortingColumn ==='email' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='email' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.emailAddress }}</td>
          </ng-container>
          <ng-container matColumnDef="mainNumber">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('mainNumber')" matTooltip="Sort by Main Number">
                Main Number
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='mainNumber'"
                  [class.fa-sort-asc]="sortingColumn ==='mainNumber' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='mainNumber' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.mainNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="lastUpdated">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('lastUpdated')" matTooltip="Sort by Last Updated">
                Last Updated
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='lastUpdated'"
                  [class.fa-sort-asc]="sortingColumn ==='lastUpdated' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='lastUpdated' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.lastUpdated | date:'short' }}</td>
          </ng-container>
          <ng-container matColumnDef="faxNumber">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('faxNumber')" matTooltip="Sort by Fax Number">
                Fax Number
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='faxNumber'"
                  [class.fa-sort-asc]="sortingColumn ==='faxNumber' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='faxNumber' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.faxNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef>
              <button class="btn btn-link" (click)="sortData('notes')" matTooltip="Sort by Notes">
                Notes
                <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='notes'"
                  [class.fa-sort-asc]="sortingColumn ==='notes' && sortOrder === 'asc'"
                  [class.fa-sort-desc]="sortingColumn ==='notes' && sortOrder === 'desc'"></i>
              </button>
            </th>
            <td mat-cell *matCellDef="let association">{{ association.notes }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true" class="headerstyle"></tr>
          <tr mat-row *matRowDef="let association; columns: columnsToDisplay"></tr>
        </table>
      </div>

    </section>

      <div>
      <mat-paginator class="pagination" [length]="totalItems" [hidePageSize]="isHidePageSize"
      [showFirstLastButtons]="showFirstLastButtons" (page)="onPageChange($event)" aria-label="Select page">
      </mat-paginator>
    </div>
    
  </div>
  <!-- Table spinner -->
  <div *ngIf="isLoading" class="spinner-wrapper">
    <mat-spinner diameter="32" color="primary"></mat-spinner>
  </div>
</div>